import gql from 'graphql-tag'

export const GET_BANNER_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getBannerPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleRu
        titleKg
        image
      }
    }
  }
`

export const GET_BANNER_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getBanner (
      data: {
        id: $id
      }
    ) {
      id
      titleEn
      titleRu
      titleKg
      position
      hidden
      link
      image
    }
  }
`;

